import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

// Müşterinin çocuklarını çek
export const fetchChildrenByCustomer = createAsyncThunk(
  "children/fetchChildrenByCustomer",
  async (customerId) => {
    const res = await axios.get(`${BASE_URL}/children/customer/${customerId}`);
    return res.data;
  }
);

// Tek çocuk detayı çek
export const fetchChildById = createAsyncThunk(
  "children/fetchChildById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/children/${id}`);
    return res.data;
  }
);

// Yeni çocuk oluştur
export const createChild = createAsyncThunk(
  "children/createChild",
  async (childData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/children`, childData);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Çocuk oluşturulamadı"
      );
    }
  }
);

// Çocuk güncelle
export const updateChild = createAsyncThunk(
  "children/updateChild",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/children/${id}`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Çocuk bilgileri güncellenemedi"
      );
    }
  }
);

// Çocuk sil
export const deleteChild = createAsyncThunk(
  "children/deleteChild",
  async (id) => {
    await axios.delete(`${BASE_URL}/children/${id}`);
    return id;
  }
);

const childSlice = createSlice({
  name: "children",
  initialState: {
    items: [],
    selectedChild: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedChild: (state) => {
      state.selectedChild = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch By Customer
      .addCase(fetchChildrenByCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChildrenByCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchChildrenByCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch By ID
      .addCase(fetchChildById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChildById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedChild = action.payload;
      })
      .addCase(fetchChildById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createChild.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createChild.fulfilled, (state, action) => {
        state.loading = false;
        state.items.unshift(action.payload);
      })
      .addCase(createChild.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateChild.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateChild.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.map((child) =>
          child._id === action.payload._id ? action.payload : child
        );
        if (state.selectedChild?._id === action.payload._id) {
          state.selectedChild = action.payload;
        }
      })
      .addCase(updateChild.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteChild.fulfilled, (state, action) => {
        state.items = state.items.filter((c) => c._id !== action.payload);
        if (state.selectedChild?._id === action.payload) {
          state.selectedChild = null;
        }
      });
  },
});

export const { clearError, clearSelectedChild } = childSlice.actions;
export default childSlice.reducer;
